
export const riskParameters = {    
    maxRiskDescription:6400,
    maxRiskStatement:500,
    maxBusinessImpact:500,
    maxComments:6400
};
